"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useKeyborg", {
    enumerable: true,
    get: function() {
        return useKeyborg;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _keyborg = require("keyborg");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
function useKeyborg() {
    const { targetDocument } = (0, _reactsharedcontexts.useFluent_unstable)();
    const keyborg = _react.useMemo(()=>targetDocument && (0, _keyborg.createKeyborg)(targetDocument.defaultView), [
        targetDocument
    ]);
    _react.useEffect(()=>{
        return ()=>keyborg && (0, _keyborg.disposeKeyborg)(keyborg);
    }, [
        keyborg
    ]);
    return keyborg;
}
